var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYellowStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 11,
  viewBox: "0 0 12 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 0L7.13894 2.59156L7.6908 3.84774L9.0998 3.96091L12 4.19856L9.79256 6.04321L8.72407 6.93724L9.04109 8.27263L9.69863 11L7.20939 9.55144L6 8.82716L4.79061 9.52881L2.30137 10.9774L2.9589 8.25L3.27593 6.91461L2.20744 6.02058L0 4.17593L2.9002 3.93827L4.3092 3.8251L4.86106 2.56893L6 0V0Z",
  fill: "#F4BF00"
})));
export { SvgYellowStar as ReactComponent };
export default __webpack_public_path__ + "deff2cb45161cb7e8c6298c6bfe2b47a.svg";